import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

const HomepageHeroTextReel = ({ items }) => {
	const swiperRef = useRef(null);
	const [slideWidth, setSlideWidth] = useState(410);

	const slideChange = function () {
		const activeSlide = document.querySelector(
			'.text-reel-carousel .swiper-slide-active'
		);
		if (activeSlide) {
			setSlideWidth(activeSlide.offsetWidth);
		}
	};

	// Add a useEffect to update the swiper width when slideWidth changes
	useEffect(() => {
		if (swiperRef.current) {
			swiperRef.current.style.width = `${slideWidth}px`;
		}
	}, [slideWidth]);

	useEffect(() => {
		const activeSlide = document.querySelector(
			'.text-reel-carousel .swiper-slide-active'
		);
		if (activeSlide) {
			setSlideWidth(activeSlide.offsetWidth);
		}
	}, []);

	return (
		<Swiper
			ref={swiperRef}
			modules={[Autoplay]}
			spaceBetween={16}
			slidesPerView={1}
			loop={true}
			direction={'vertical'}
			speed={800}
			allowTouchMove={true}
			autoplay={{
				delay: 1600,
				disableOnInteraction: false,
			}}
			tag='span'
			className='text-reel-carousel'
			onSlideChangeTransitionStart={slideChange}
			style={{ width: slideWidth }}
		>
			{items.map((text) => (
				<SwiperSlide key={text.id}>{text.text}</SwiperSlide>
			))}
		</Swiper>
	);
};
export default HomepageHeroTextReel;
